import { render, staticRenderFns } from "./AppAccessDeniedComponent.vue?vue&type=template&id=9846c1ee&scoped=true"
import script from "./AppAccessDeniedComponent.vue?vue&type=script&lang=ts"
export * from "./AppAccessDeniedComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9846c1ee",
  null
  
)

export default component.exports